import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import { zodPartnerCompanySchema } from '../useQueryPartnerCompany/validations';

/**
 * Validation schemas for the partner companies list endpoint.
 */

export const zodPartnerCompaniesQueryParamsSchema = z.object({
  companyAccountId: z.uuid().optional(),
  exchangeDlns: z.boolean().optional().prefault(false),
  includeOwn: z.boolean().optional().prefault(true),
  limit: z
    .number()
    .int()
    .min(1)
    .optional()
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().int().min(0).optional().prefault(0),
  searchString: z.string().trim().optional(),
});

export const zodPaginatedPartnerCompanyListSchema = z.object({
  data: z.array(zodPartnerCompanySchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative().nullable(),
});
